module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-answer-first"><div class="answer-first"><div class="answer-title"><img src="' +
((__t = (headsrc)) == null ? '' : __t) +
'"> <span class="title"> ' +
((__t = (title)) == null ? '' : __t) +
' </span></div><p class="body"> ' +
((__t = (msg)) == null ? '' : __t) +
' </p><div class="btn"><a class="goWatch close" id="goWatch" href="https://v.qq.com/x/cover/vxz0cpf5fawnghw/u0026nf7g8r.html?ptag=qqbrowser&ADTAG=zd-activity" target="_blank">立即去看剧</a></div></div></div>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./modules/mask/answer.num.html
// module id = 31
// module chunks = 0